ACC.checkoutsteps = {
  _autoload: ['permeateLinks'],

  permeateLinks: function() {
    $(document).on('click', '.js-checkout-step', function(e) {
      e.preventDefault();
      window.location = $(this)
        .closest('a')
        .attr('href');
    });
  }
};

$(document).ready(function() {
  if ($('#orderCreationDate').length) {
    let currentDate = new Date();
    var currentTime = currentDate.getTime();
    $('#orderCreationDate').val(currentTime);
    console.log($('#orderCreationDate').val());
  }
});
